import { cn } from "./cn";

/* Label + hint + error scaffolding shared by input, textarea and select, so the
   three never drift apart.

   FIELD_BASE deliberately carries NO border-colour or ring utility. Tailwind
   emits every colour utility at the same specificity, so two of them on one
   element are resolved by stylesheet order, not by the order you wrote them in
   the class attribute — which silently rendered invalid fields with the normal
   grey border. Exactly one of FIELD_TONE / FIELD_INVALID is applied instead. */

export const FIELD_BASE = cn(
  "w-full rounded-ns border border-solid bg-white font-body text-ui-sm text-ink",
  "placeholder:text-shade-900",
  "transition-[border-color,box-shadow] duration-ui ease-ui",
  "focus:outline-none focus:ring-2",
  "disabled:bg-shade-50 disabled:text-shade-900 disabled:cursor-not-allowed"
);

export const FIELD_TONE = cn(
  "border-rule-strong hover:border-shade-900",
  "focus:border-accent focus:ring-accent/20"
);

export const FIELD_INVALID = cn(
  "border-danger hover:border-danger",
  "focus:border-danger focus:ring-danger/20"
);

/** Exactly one border-colour source, chosen by validity. */
export const fieldClasses = (hasError, className) =>
  cn(FIELD_BASE, hasError ? FIELD_INVALID : FIELD_TONE, className);

const Field = ({ label, htmlFor, required, hint, error, className, children }) => (
  <div className={cn("flex flex-col gap-1.5", className)}>
    {label && (
      <label htmlFor={htmlFor} className="font-body text-ui-xs font-medium text-ink">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
    )}
    {children}
    {/* Error wins over hint — never show both. */}
    {error ? (
      <p className="font-body text-meta text-danger">{error}</p>
    ) : hint ? (
      <p className="font-body text-meta text-muted">{hint}</p>
    ) : null}
  </div>
);

export default Field;
